import downloadjs from "downloadjs";
import * as React from "react";
import { IEventEditItemMessage } from "ui/Scripts/source/models/event/eventEditItemMessage";
import MessageListLine from "../../../framework/Message/MessageLine/MessageLine";
import { MessageListEvent } from "../../../framework/Message/MessageListEvent";
import { AppUtils } from "source/framework/appUtils";
import * as attachmentService from "../../../../models/services/attachmentService";
import { Translations } from "ui/Scripts/source/models/translations";

export interface IEventEditDialogMessageListLineProp {
    observer: IntersectionObserver;
    message: IEventEditItemMessage;
    selectedId: string;
    lateThreshold: number;
    onClick: (id: string) => void;
}

export class EventEditDialogMessageListLine extends React.Component<IEventEditDialogMessageListLineProp, {}> {
    private observer: IntersectionObserver = null;
    private lineDiv = React.createRef<HTMLDivElement>();

    registerToObserver = () => {
        const props = this.props;
        if (!props.observer || !this.lineDiv.current || !props.message || props.message.myMessage) return;
        this.observer = props.observer;
        this.observer.observe(this.lineDiv.current);
    };

    unregisterFromObserver = () => {
        if (!this.observer || !this.lineDiv.current) return;
        this.observer.unobserve(this.lineDiv.current);
    };

    componentDidMount(): void {
        this.registerToObserver();
    }

    componentDidUpdate(prevProps: IEventEditDialogMessageListLineProp) {
        const props = this.props;
        const prevObserverExists = !!prevProps.observer;
        const observerExists = !!props.observer;
        if (prevObserverExists === observerExists) return;
        this.unregisterFromObserver();
        if (observerExists) {
            this.registerToObserver();
        }
    }

    componentWillUnmount(): void {
        this.unregisterFromObserver();
    }

    handleAttachmentClick = async (id: string) => {
        if (!id) return;
        const props = this.props;
        const attachment = props.message.attachments.find(i => i.id === id);
        if (!attachment) return;
        if (attachment.file) {
            downloadjs(attachment.file, attachment.name);
            return;
        }
        if (attachment.isNew()) return;
        const fileName = await AppUtils.callService(() => attachmentService.getAttachment(id));
        if (!fileName) return;
        AppUtils.showSuccessMessage(String.format(Translations.AttachmentParameterDownloaded, fileName));
    };

    render() {
        const props = this.props;
        const message = props.message;
        const timeToleranceInJsTicks = 500;
        const isLate = props.lateThreshold && message.modifyUser.date > (props.lateThreshold + timeToleranceInJsTicks);
        if (message.uiType < 0.5) {
            return (
                <MessageListLine
                    ref={this.lineDiv}
                    id={message.id}
                    content={message.content}
                    attachments={message.attachments}
                    date={message.modifyUser.date}
                    myMessage={message.myMessage}
                    sender={message.modifyUser.name}
                    allRead={message.allRead}
                    isLate={isLate}
                    onClick={props.onClick}
                />
            );
        }
        return (
            <MessageListEvent
                name={message.modifyUser.name}
                uiType={message.uiType}
                date={message.modifyUser.date}
            />
        );
    }
}